import "./VerificationPage.css";
import React from "react";
import FormImage from "../../Assets/images/login.png";
import { Link } from "react-router-dom";
import VerificationPageViewModel from "./VerificationPageViewModel";

const VerificationPage = () => {
  const [AuthUser, ResendEmail] = VerificationPageViewModel();

  return (
    <div className="main-wrapper verification-body">
      <div className="verification-wrapper">
        <div className="container">
          <div className="verificationbox">
            <div className="verification-left">
              <img className="img-fluid" src={FormImage} alt="Logo" />
            </div>
            <div className="verification-right">
              <div className="verification-right-wrap">
                <h1>Email Verification</h1>
                <form>
                  <div className="form-group">
                    We have sent an email to{" "}
                    <span className="auth-email">{AuthUser?.email}</span> , with
                    the link in it. Please open your email inbox and click on
                    the link to verify your email. <br /> Come back to this page
                    after click on the link in email inbox.
                  </div>

                  <div className="form-group">
                    Did not receive an email? click{" "}
                    <span onClick={ResendEmail} className="resend-email">
                      HERE
                    </span>{" "}
                    to resend it.
                  </div>

                  {/* {AuthUser?.emailVerified === true && ( */}
                  <div className="form-group">
                    <Link
                      to="/login"
                      className="btn btn-primary btn-block"
                      type="submit"
                    >
                      Login
                    </Link>
                  </div>
                  {/* )} */}
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VerificationPage;
